import NoticeOther from './NoticeOther'
export default NoticeOther
